import React from 'react';
import { LabelInput } from '../../../atoms/Inputs/LabelInput';
import { addEleveFormErrorHandling } from '../../../../helpers/forms/formsErrorHandling/addEleveErrorHandling';

export const EleveFields = ({ setEleveForm, eleveForm }) => (
  <div>
    <LabelInput
      label="Prénom"
      placeHolder={'Thomas'}
      onChange={e =>
        setEleveForm(
          addEleveFormErrorHandling(eleveForm, 'firstname', e.target.value)
        )
      }
      name="firstname"
      type="text"
      value={eleveForm.values.firstname || ''}
      error={eleveForm.errors && eleveForm.errors.firstname}
    />
    <LabelInput
      label="Nom de famille"
      placeHolder={'Dupont'}
      onChange={e =>
        setEleveForm(
          addEleveFormErrorHandling(eleveForm, 'lastname', e.target.value)
        )
      }
      name="lastname"
      type="text"
      value={eleveForm.values.lastname || ''}
      error={eleveForm.errors && eleveForm.errors.lastname}
    />
  </div>
);
